import React from 'react';

import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

export default function WarningButton(props)
{
  return {
      style : { color : "red" },
      label : props.label,
      "aria-label" : props.text,
      icon : <ErrorOutlineIcon />,
      ...props
  }
}